export default __webpack_public_path__ + "3809bb8d1ef6a8f38befd44c970e2849.svg";